// extracted by mini-css-extract-plugin
module.exports = {"title":"Valeurs_title__3lk-_","item":"Valeurs_item__3QhWe","subtitle":"Valeurs_subtitle__2WF-n","active":"Valeurs_active__1wi1k"};